const isBrowser = typeof window !== 'undefined' && typeof window.localStorage !== 'undefined';

export const loadDraft = (key, fallback) => {
  if (!isBrowser) return fallback;

  try {
    const rawValue = window.localStorage.getItem(key);
    if (!rawValue) return fallback;
    return JSON.parse(rawValue);
  } catch (error) {
    console.error(`Failed to load draft for key "${key}"`, error);
    return fallback;
  }
};

export const saveDraft = (key, value) => {
  if (!isBrowser) return;

  try {
    window.localStorage.setItem(key, JSON.stringify(value));
  } catch (error) {
    console.error(`Failed to save draft for key "${key}"`, error);
  }
};

export const clearDraft = (key) => {
  if (!isBrowser) return;

  try {
    window.localStorage.removeItem(key);
  } catch (error) {
    console.error(`Failed to clear draft for key "${key}"`, error);
  }
};
